import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from "react";
import PropTypes from "prop-types";

// This is done so that documentation can be generated
const validationPropTypes = {
  /**
   * The aspect ratio of an image
   */
  aspectRatio: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number
  }),
  /**
   * Override default error messages, this supports all the validations found in the enumeration.
   *
   * `import { validationNames } from "../Validations"`
   */
  errorMessages: PropTypes.object,
  /**
   * The maximum height for an image
   */
  maxHeight: PropTypes.number,
  /**
   * The minimum height for an image
   */
  minHeight: PropTypes.number,
  /**
   * The maximum value for the input required
   */
  maxLength: PropTypes.number,
  /**
   * The minimum value for the input required
   */
  minLength: PropTypes.number,
  /**
   * The maximum value allows for the input
   */
  maxValue: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.number]),
  /**
   * The minimum value allowed for the input
   */
  minValue: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.number]),
  /**
   * The maximum width of an image
   */
  maxWidth: PropTypes.number,
  /**
   * The minimum width of an image
   */
  minWidth: PropTypes.number,
  /**
   * The regular expression used to validated the value of the input. We expect the regular expression to be escaped. Please see examples below.
   *
   * - Not Escaped: `^\d{5}([\-]\d{4})?$`
   *
   * - Escaped: `^\\d{5}([\\-]\\d{4})?$`
   */
  regExpPattern: PropTypes.oneOfType([PropTypes.instanceOf(RegExp), PropTypes.string]),
  /**
   * If `true` the label will indicate that the input is required.
   */
  required: PropTypes.bool,
  /**
   * Validations to apply to the field.
   *
   * `async (value, props, component) => { return { error: ..., message: ..., validationName: ... } }`
   */
  validations: PropTypes.arrayOf(PropTypes.func),
  /**
   * The value of the component.
   */
  value: PropTypes.any
};

// This is done so that documentation can be generated
// eslint-disable-next-line @typescript-eslint/no-unused-vars
class Validations extends React.Component {}
_defineProperty(Validations, "propTypes", validationPropTypes);
export default validationPropTypes;